/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Action_Mark_PaidInputs */

const vi_tea_purchase_action_mark_paid = /** @type {(inputs: Tea_Purchase_Action_Mark_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh dấu đã thanh toán`)
};

/**

* @param {Tea_Purchase_Action_Mark_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_action_mark_paid = /** @type {((inputs?: Tea_Purchase_Action_Mark_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Action_Mark_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_action_mark_paid(inputs)
});